import dbVersion from './db-version.json'

export const PAGE_TITLE = 'Zi Zi Bu Wang'
export const TITLE_DELIMITER = ' - '
export const TITLE_SEGMENT_TRUNCATE_LENGTH = 50

export const DB_VERSION = dbVersion
export const MAX_TIMEOUT = 10_000
export const DB_NAME = 'dict_data'
export const CEDICT_TABLE_NAME = 'cedict'

export const RESULTS_PER_PAGE = 50
